import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';
import { creaditNoteReason } from './creaditNotereason';

export interface CreditNoteDetParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface CreditNoteDet {
    id?: any;
    creditNoteDate:Date;
    creditNoteNo?:string;
    suplId:string;
    creditNoteReasonId:string;
    suplNotes:string;
    amount:number;
    createdBy:string;
    tenantId: string;
    branchId: string;
    createdDate:Date;
    supplier?:any;
    creditNoteReason?:creaditNoteReason;

    
    parameters?: CreditNoteDetParameter[];
    links?: any;
}


export abstract class CreditNoteDetData {
    
    abstract list(url: string): Observable<CreditNoteDet[]>;
    abstract create(url: string, data: CreditNoteDet): Observable<CreditNoteDet[]>;
    abstract update(url: string, data: CreditNoteDet): Observable<CreditNoteDet>;
    abstract delete(url: string): Observable<any>;
    abstract getById(url: string): Observable<CreditNoteDet>;
}
